"use strict";

/* eslint-disable no-param-reassign */
module.exports = /*@ngInject*/function () {
  return {
    restrict: 'AE',
    scope: true,
    bindToController: {
      attachments: '=',
      canDelete: '=',
      remove: '&',
      preview: '&',
      isPublicView: '=',
      shareableToken: '='
    },
    template: "\n      <div class=\"attachments\" ng-init=\"$ctrl.onInit()\">\n        <div class=\"photos\">\n          <div ng-repeat=\"photo in photos = ($ctrl.attachments | filter: 'IMAGE')\" class=\"photo\">\n            <img ng-src=\"{{ photo.$$thumbnailUrl || photo.$$signedUrl }}\" class=\"thumbnail\" ng-click=\"$ctrl.preview({ attachment: photo })\" alt=\"{{ photo.originalName }}\">\n          </div>\n        </div>\n\n        <strong ng-if=\"documents.length > 0\">Documents:</strong>\n        <div ng-repeat=\"document in documents = ($ctrl.attachments | filter:'DOCUMENT')\" >\n          <div>{{ document.name }}</div>\n          <a href=\"{{document.$$signedUrl}}\">Download</a>\n          <a ng-if=\"$ctrl.canDelete && !$ctrl.isPublicView\" class=\"link\" ng-click=\"$ctrl.remove()(document)\">Delete</div>\n        </div>\n      </div>\n    ",
    controllerAs: '$ctrl',
    // eslint-disable-next-line func-names, object-shorthand
    controller: /*@ngInject*/function controller($http, $q) {
      var $ctrl = this;
      $ctrl.onInit = function () {
        $q.all($ctrl.attachments.filter(function (attachment) {
          return !attachment.$$signedUrl;
        }).map(function (attachment) {
          var route = $ctrl.isPublicView ? "api/public/report/".concat($ctrl.shareableToken, "/attachment/").concat(attachment.s3Name, "/download") : "api/report/attachment/".concat(attachment.s3Name, "/download");
          return $http.get(route).then(function (_ref) {
            var data = _ref.data;
            attachment.$$signedUrl = data.signedUrl;
            attachment.$$thumbnailUrl = data.thumbnailUrl;
          });
        }));
      };
    }
  };
};